import { render, staticRenderFns } from "./SendProposalDialog.vue?vue&type=template&id=828ca8be&scoped=true"
import script from "./SendProposalDialog.vue?vue&type=script&lang=js"
export * from "./SendProposalDialog.vue?vue&type=script&lang=js"
import style0 from "./SendProposalDialog.vue?vue&type=style&index=0&id=828ca8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828ca8be",
  null
  
)

export default component.exports